import React, {useState} from "react";

const ValueGeneration = ({volumeDaily, volumeWeekly, volumeMonthly, volumeQuarterly, volumeSemiAnnually, volumeAnnually}) => {
  const FEE_PERCENT = 6;
  const feeData = {
    "24h": {
      label: "24 Hours",
      total: parseFloat(volumeDaily * FEE_PERCENT / 100).toFixed(2),
      breakdown: {
        UFOReflection: parseFloat(volumeDaily * 0.01).toFixed(2),
        UFOBuyBurn: parseFloat(volumeDaily * 0.01).toFixed(2),
        PTGCBuyBurn: parseFloat(volumeDaily * 0.01).toFixed(2),
        UFOLPing: parseFloat(volumeDaily * 0.03).toFixed(2),
      }
    },
    "7d": {
      label: "7 Days",
      total: parseFloat(volumeWeekly * FEE_PERCENT / 100).toFixed(2),
      breakdown: {
        UFOReflection: parseFloat(volumeWeekly * 0.01).toFixed(2),
        UFOBuyBurn: parseFloat(volumeWeekly * 0.01).toFixed(2),
        PTGCBuyBurn: parseFloat(volumeWeekly * 0.01).toFixed(2),
        UFOLPing: parseFloat(volumeWeekly * 0.03).toFixed(2),
      }
    },
    "30d": {
      label: "30 Days",
      total: parseFloat(volumeMonthly * FEE_PERCENT / 100).toFixed(2),
      breakdown: {
        UFOReflection: parseFloat(volumeMonthly * 0.01).toFixed(2),
        UFOBuyBurn: parseFloat(volumeMonthly * 0.01).toFixed(2),
        PTGCBuyBurn: parseFloat(volumeMonthly * 0.01).toFixed(2),
        UFOLPing: parseFloat(volumeMonthly * 0.03).toFixed(2),
      }
    },
    "90d": {
      label: "90 Days",
      total: parseFloat(volumeQuarterly * FEE_PERCENT / 100).toFixed(2),
      breakdown: {
        UFOReflection: parseFloat(volumeQuarterly * 0.01).toFixed(2),
        UFOBuyBurn: parseFloat(volumeQuarterly * 0.01).toFixed(2),
        PTGCBuyBurn: parseFloat(volumeQuarterly * 0.01).toFixed(2),
        UFOLPing: parseFloat(volumeQuarterly * 0.03).toFixed(2),
      }
    },
    "180d": {
      label: "180 Days",
      total: parseFloat(volumeSemiAnnually * FEE_PERCENT / 100).toFixed(2),
      breakdown: {
        UFOReflection: parseFloat(volumeSemiAnnually * 0.01).toFixed(2),
        UFOBuyBurn: parseFloat(volumeSemiAnnually * 0.01).toFixed(2),
        PTGCBuyBurn: parseFloat(volumeSemiAnnually * 0.01).toFixed(2),
        UFOLPing: parseFloat(volumeSemiAnnually * 0.03).toFixed(2),
      }
    }, 
    "365d": { 
      label: "1 Year",
      total: (volumeAnnually * FEE_PERCENT / 100).toFixed(2),
      breakdown: {
        UFOReflection: parseFloat(volumeAnnually * 0.01).toFixed(2),
        UFOBuyBurn: parseFloat(volumeAnnually * 0.01).toFixed(2),
        PTGCBuyBurn: parseFloat(volumeAnnually * 0.01).toFixed(2),
        UFOLPing: parseFloat(volumeAnnually * 0.03).toFixed(2),
      }
    }
  };
  
  const [selected, setSelected] = useState("24h");
  const handleSelect = (period) => {
    setSelected(period);
  };
  const selectedData = feeData[selected];
  return (
    <div className="UFOSEC tarnsaGold statsALL">
      <div className="UFO-fee-allo">
        <div className="topcards hoverboxes gredientBG mb-3" style={{border:'0px'}}>
        <div className=" row">
          {Object.entries(feeData).map(([key, card]) => (
            <div className='col-lg-4'  data-aos="fade-up"  data-aos-delay="600" data-aos-duration="400">
              <div
                key={key}
                className={`freesMulti ${selected === key ? "active" : ""}`}
                onClick={() => handleSelect(key)}
              >
                <div className="card-label fInter"><i className="fa-solid fa-calendar-days"></i> {card.label}</div>
                <div className="dollorVal f18 mt-0">
                  <span className="dollor">$</span>
                  <span className="val f18">{parseFloat(card.total).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
                </div>
                <div className="card-subtext fInter">$ Fees Collected</div>
              </div>
            </div>
          ))}
        </div>
        </div>
        <div className="topcards pt-0">
        <div className="note" data-aos="fade-up"  data-aos-delay="700" data-aos-duration="400">
         <i className="fa-solid fa-circle-info"></i>  All values represent 6% of total UFO trading volume for each time period
        </div>
        <div className="row">
          <div className='col-lg-3' data-aos="fade-up"  data-aos-delay="800" data-aos-duration="400">
            <div className="freesMulti">
              <div className="card-label fInter">Reflection Reward</div>
              <div className="dollorVal f28 mt-0 mb-0">
                <span className="dollor">$</span>
                <span className="val f28">{parseFloat(selectedData.breakdown.UFOReflection).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
              </div>
              <div className="card-subtext fInter">1% allocated to reflection</div>
            </div>
          </div>

          <div className='col-lg-3' data-aos="fade-up"  data-aos-delay="900" data-aos-duration="400">
            <div className="freesMulti">
              <div className="card-label fInter">UFO Buy & Burn</div>
              <div className="dollorVal f28 mt-0 mb-0">
                <span className="dollor">$</span>
                <span className="val f28">{parseFloat(selectedData.breakdown.UFOBuyBurn).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
              </div>
              <div className="card-subtext fInter">1% allocated to UFO buy & burns</div>
            </div>
          </div>

          <div className='col-lg-3' data-aos="fade-up"  data-aos-delay="1000" data-aos-duration="400">
            <div className="freesMulti">
              <div className="card-label fInter">PTGC Buy & Burn</div>
              <div className="dollorVal f28 mt-0 mb-0">
                <span className="dollor">$</span>
                <span className="val f28">{parseFloat(selectedData.breakdown.PTGCBuyBurn).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
              </div>
              <div className="card-subtext fInter">1% allocated to PTGC buy & burn</div>
            </div>
          </div>
          <div className='col-lg-3' data-aos="fade-up"  data-aos-delay="1100" data-aos-duration="400">
            <div className="freesMulti">
              <div className="card-label fInter">UFO LPing</div>
              <div className="dollorVal f28 mt-0 mb-0">
                <span className="dollor">$</span>
                <span className="val f28">{parseFloat(selectedData.breakdown.UFOLPing).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
              </div>
              <div className="card-subtext fInter">3% allocated to UFO LPing</div>
            </div>
          </div>
        </div>
      </div>
      </div>
    </div>
  );
};

export default ValueGeneration;
